import { useNuxtApp } from '#imports'

import { CurrencyAmount } from '~/utils/CurrencyAmount'
import { resolveDisplayLocale } from '~/utils/resolveDisplayLocale'

/** Formats an amount in the default currency for the active locale, e.g. `$12.50`. */
export function useCurrencyFormat() {
  const { $i18n } = useNuxtApp()
  return (value: number | string | null | undefined): string =>
    CurrencyAmount.format(
      value,
      CurrencyAmount.defaultCurrency,
      resolveDisplayLocale(String($i18n.locale.value))
    )
}
